import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import styles from './styles.css';
import messages from './messages';
import DefListColumn from '../DefListColumn';

const TransferPanelAchDetails = ({
  bankAccountNumber,
  bankAccountIdentifierValue,
  establishedDate,
}) => (
  <div className={styles.rightPane}>
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.bankAccount} />}
      data={bankAccountNumber}
      dataTestHandle="achRelationshipsPanel__bankAccount"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.routingNumber} />}
      data={bankAccountIdentifierValue}
      dataTestHandle="achRelationshipsPanel__routingNumber"
    />
    <DefListColumn
      className={styles.defList}
      title={<FormattedMessage {...messages.established} />}
      data={establishedDate}
      dataTestHandle="achRelationshipsPanel__established"
    />
  </div>
);

TransferPanelAchDetails.propTypes = {
  bankAccountNumber: PropTypes.string.isRequired,
  bankAccountIdentifierValue: PropTypes.string.isRequired,
  establishedDate: PropTypes.string.isRequired,
};

export default TransferPanelAchDetails;



// WEBPACK FOOTER //
// ./src/components/TransferPanelAchDetails/index.js